var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBsdLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#F4F2ED",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    d: "M146.655 161.923C151.184 202.415 189.673 203.509 206.653 207.887C256.462 217.736 231.558 236.341 211.181 236.341L212.313 239.624L169.296 240.719L204.389 221.02L207.785 229.775C213.445 231.963 250.802 218.831 190.805 213.359C165.9 208.981 150.051 203.509 140.995 192.566L110.43 210.076C102.506 192.566 78.7335 185.999 88.9218 163.017"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M146.655 161.923C151.184 202.415 189.673 203.509 206.653 207.887C256.462 217.736 231.558 236.341 211.181 236.341L212.313 239.624L169.296 240.719L204.389 221.02L207.785 229.775C213.445 231.963 250.802 218.831 190.805 213.359C165.9 208.981 150.051 203.509 140.995 192.566L110.43 210.076C102.506 192.566 78.7335 185.999 88.9218 163.017"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M139.863 185.999C142.127 187.094 145.523 182.716 144.391 180.527L61.7531 121.431C61.7531 118.148 69.6773 111.581 58.357 102.826L59.4891 100.637L44.7727 94.071C47.0367 98.4486 49.3008 99.543 51.5648 107.204L56.093 105.015C60.6211 110.487 60.6211 114.864 56.093 117.053L48.1687 111.581C48.1687 110.487 49.3008 109.392 49.3008 108.298C49.3008 108.298 48.1687 107.204 44.7727 107.204C42.5086 107.204 37.9805 102.826 34.5844 102.826C34.5844 106.109 40.2445 111.581 40.2445 117.053L43.6406 114.864C47.0367 115.959 49.3008 118.148 51.5648 121.431C48.1687 125.808 43.6406 127.997 34.5844 123.619C34.5844 121.431 36.8484 120.336 36.8484 118.148C32.3203 118.148 26.6602 114.864 21 111.581C23.2641 119.242 30.0562 127.997 36.8484 130.186C48.1687 134.563 52.6969 126.903 58.357 126.903L139.863 185.999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    d: "M108.166 114.864L74.2055 74.3721C76.4695 68.9002 75.3375 61.2395 74.2055 57.9563C68.5453 39.899 80.9977 31.6911 92.318 22.936C101.374 16.3697 105.902 15.2753 108.166 16.3697C110.43 18.5585 99.1102 25.1248 96.8461 32.7855C96.8461 32.7855 94.582 44.8237 102.506 39.3518C109.298 36.0686 118.355 33.8799 128.543 36.0686C136.467 37.163 148.92 41.5406 156.844 50.2956C180.616 45.9181 167.032 31.6911 164.768 22.936C172.692 16.3697 214.011 56.862 163.636 83.1272C163.636 98.4486 160.24 108.298 150.052 117.053C137.599 126.903 145.523 131.28 147.788 137.846C153.448 156.451 151.184 168.489 128.543 171.772C112.695 173.961 110.43 180.527 97.9781 171.772"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M108.166 114.864L74.2055 74.3721C76.4695 68.9002 75.3375 61.2395 74.2055 57.9563C68.5453 39.899 80.9977 31.6911 92.318 22.936C101.374 16.3697 105.902 15.2753 108.166 16.3697C110.43 18.5585 99.1102 25.1248 96.8461 32.7855C96.8461 32.7855 94.582 44.8237 102.506 39.3518C109.298 36.0686 118.355 33.8799 128.543 36.0686C136.467 37.163 148.92 41.5406 156.844 50.2956C180.616 45.9181 167.032 31.6911 164.768 22.936C172.692 16.3697 214.011 56.862 163.636 83.1272C163.636 98.4486 160.24 108.298 150.052 117.053C137.599 126.903 145.523 131.28 147.788 137.846C153.448 156.451 151.184 168.489 128.543 171.772C112.695 173.961 110.43 180.527 97.9781 171.772"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    d: "M102.506 49.2013C103.638 44.8238 92.3179 37.1631 79.8656 60.1452C78.7335 63.4283 74.2054 72.1834 74.2054 72.1834C73.0734 76.5609 71.9413 82.0329 69.6773 84.2216C58.357 95.1655 64.0171 109.392 78.7335 114.864C82.1296 115.959 92.3179 123.619 99.1101 126.903C102.506 129.091 99.1101 136.752 93.4499 135.658C62.8851 129.091 61.7531 149.885 74.2054 153.168L118.355 150.979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M102.506 49.2013C103.638 44.8238 92.3179 37.1631 79.8656 60.1452C78.7335 63.4283 74.2054 72.1834 74.2054 72.1834C73.0734 76.5609 71.9413 82.0329 69.6773 84.2216C58.357 95.1655 64.0171 109.392 78.7335 114.864C82.1296 115.959 92.3179 123.619 99.1101 126.903C102.506 129.091 99.1101 136.752 93.4499 135.658C62.8851 129.091 61.7531 149.885 74.2054 153.168L118.355 150.979"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M109.298 48.1068C113.826 43.7292 121.751 43.7292 125.147 50.2956C126.279 52.4843 126.279 54.6731 127.411 55.7675"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    d: "M76.4695 107.204C82.1296 108.298 82.1296 111.581 88.9218 117.053C100.242 125.808 113.827 118.147 117.223 115.959C121.751 113.77 121.751 110.487 126.279 112.676"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M76.4695 107.204C82.1296 108.298 82.1296 111.581 88.9218 117.053C100.242 125.808 113.827 118.147 117.223 115.959C121.751 113.77 121.751 110.487 126.279 112.676"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    d: "M91.186 91.8823C77.6017 84.2216 74.2056 96.2598 79.8657 101.732C80.9978 102.826 84.3938 102.826 86.6579 103.921C88.922 105.015 90.054 100.637 95.7142 103.373C100.242 106.109 102.506 100.637 97.9782 98.4486"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M91.186 91.8823C77.6017 84.2216 74.2056 96.2598 79.8657 101.732C80.9978 102.826 84.3938 102.826 86.6579 103.921C88.922 105.015 90.054 100.637 95.7142 103.373C100.242 106.109 102.506 100.637 97.9782 98.4486"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M99.1102 54.6733C99.1102 51.3901 92.318 49.2014 84.3937 61.2396C75.3375 75.4666 76.4695 83.1273 80.9977 86.4104C84.3937 88.5992 87.7898 87.5048 91.1859 77.6554C93.45 72.1834 99.1102 57.9564 99.1102 54.6733Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M112.694 53.5788C124.015 51.39 122.883 91.8823 104.77 92.9766C84.3937 94.071 97.9781 56.8619 112.694 53.5788Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M107.034 73.2775C112.694 77.655 105.902 95.1652 97.978 88.5989C92.3179 83.127 100.242 67.8056 107.034 73.2775Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M87.7898 71.0888C93.4499 75.4664 84.3937 89.6934 80.9976 83.1271C77.6015 78.7495 80.9976 66.7113 87.7898 71.0888Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84.3936 72.1831C85.5257 72.1831 85.5257 78.7494 84.3936 78.7494C80.9975 78.7494 82.1296 72.1831 84.3936 72.1831Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102.506 76.5608C103.638 76.5608 103.638 80.9383 101.374 80.9383C100.242 80.9383 99.1102 76.5608 102.506 76.5608Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    d: "M104.77 171.772C99.1102 171.772 95.7141 172.867 88.9219 165.206Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M104.77 171.772C99.1102 171.772 95.7141 172.867 88.9219 165.206"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    d: "M99.1102 165.206C69.6774 167.395 92.318 126.902 114.959 144.413C119.487 147.696 124.015 148.79 130.807 146.601"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M99.1102 165.206C69.6774 167.395 92.318 126.902 114.959 144.413C119.487 147.696 124.015 148.79 130.807 146.601"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M94.5821 145.507C97.9782 150.979 86.6579 159.734 79.8657 154.262C73.0735 148.79 91.186 141.13 94.5821 145.507Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M87.7898 134.563C61.753 131.28 62.8851 149.885 74.2054 153.168C86.6577 156.451 100.242 138.941 87.7898 134.563Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M80.9977 140.035C82.1297 147.696 65.1492 152.073 61.7532 141.129C59.4891 133.469 78.7336 122.525 80.9977 140.035Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M84.3937 124.714C91.1859 133.469 74.2054 137.846 69.6773 132.374C60.621 122.525 78.7335 118.147 84.3937 124.714Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M60.6211 206.793C75.3375 205.698 100.242 205.698 93.45 194.754C91.1859 191.471 92.318 189.283 92.318 187.094C94.582 195.849 112.695 190.377 111.562 201.321L90.0539 229.775L60.6211 206.793Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B000",
    d: "M126.279 195.849C130.807 193.66 135.335 195.849 139.863 192.566C147.787 200.226 147.787 211.17 150.051 213.359L111.562 228.68L86.6577 216.642C97.978 203.509 110.43 208.981 111.562 201.321C113.826 188.188 120.619 191.471 126.279 196.943C126.279 196.943 127.411 207.887 124.015 207.887C116.091 208.981 99.1101 215.548 99.1101 215.548"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M126.279 195.849C130.807 193.66 135.335 195.849 139.863 192.566C147.787 200.226 147.787 211.17 150.051 213.359L111.562 228.68L86.6577 216.642C97.978 203.509 110.43 208.981 111.562 201.321C113.826 188.188 120.619 191.471 126.279 196.943C126.279 196.943 127.411 207.887 124.015 207.887C116.091 208.981 99.1101 215.548 99.1101 215.548"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M41.3765 212.265C43.6405 208.982 75.3374 200.226 75.3374 213.359L56.0929 223.209L41.3765 212.265Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4FFF4",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M142.127 203.51C142.127 211.17 135.335 210.076 134.203 206.793C131.939 199.132 142.127 198.038 142.127 203.51Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.4133 223.208C39.1125 226.492 39.1125 218.831 39.1125 218.831C39.1125 213.359 39.1125 213.359 41.3766 212.265C44.7727 216.642 64.0172 218.831 73.0735 214.453"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M67.4133 223.208C39.1125 226.492 39.1125 218.831 39.1125 218.831C39.1125 213.359 39.1125 213.359 41.3766 212.265C44.7727 216.642 64.0172 218.831 73.0735 214.453"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M108.167 224.303C108.167 204.604 75.3376 206.793 68.5454 218.831L83.2618 229.775L108.167 224.303Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M148.92 212.265C151.184 211.17 150.052 215.548 150.052 219.925C127.411 234.152 79.8657 235.247 67.4133 225.397C67.4133 221.02 67.4133 219.925 68.5454 217.736C75.3375 228.68 139.863 224.303 148.92 212.265Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#D10000",
    d: "M95.7141 199.132L107.034 200.226L95.7141 199.132ZM93.45 202.415L104.77 204.604L93.45 202.415ZM87.7899 204.604L96.8461 206.793L87.7899 204.604ZM78.7336 206.793L92.318 208.982L78.7336 206.793ZM112.695 200.226L126.279 201.321L112.695 200.226ZM111.563 203.51L125.147 205.698L111.563 203.51ZM107.034 206.793L114.959 207.887L107.034 206.793ZM100.242 208.982L109.298 210.076Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113,
    d: "M100.242 208.982L109.298 210.076M95.7141 199.132L107.034 200.226L95.7141 199.132ZM93.45 202.415L104.77 204.604L93.45 202.415ZM87.7899 204.604L96.8461 206.793L87.7899 204.604ZM78.7336 206.793L92.318 208.982L78.7336 206.793ZM112.695 200.226L126.279 201.321L112.695 200.226ZM111.563 203.51L125.147 205.698L111.563 203.51ZM107.034 206.793L114.959 207.887L107.034 206.793Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsdLight);
export default __webpack_public_path__ + "static/media/BSD-Light.dad9d63b0aba82fded8ada094c4bf5c5.svg";
export { ForwardRef as ReactComponent };